/* RigStrips custom navigation: desktop mega menu + mobile drawer */
(function () {
  var OPEN_DELAY = 150;
  var CLOSE_DELAY = 250;

  function headerBottom(nav) {
    var wrap = nav.closest('sticky-header') || nav.closest('.header-wrapper') || nav.closest('header');
    return Math.max(0, Math.round((wrap || nav).getBoundingClientRect().bottom));
  }

  function initNav(nav) {
    if (nav.dataset.rsReady) return;
    nav.dataset.rsReady = '1';
    var scrim = nav.querySelector('[data-rs-scrim]');
    var current = null;
    var openTimer;
    var closeTimer;

    function setTop() {
      nav.style.setProperty('--rs-top', headerBottom(nav) + 'px');
    }

    function close(item) {
      if (!item) return;
      var btn = item.querySelector('[data-rs-trigger]');
      var panel = item.querySelector('[data-rs-panel]');
      if (panel) panel.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (current === item) {
        current = null;
        if (scrim) scrim.hidden = true;
      }
    }

    function open(item) {
      clearTimeout(closeTimer);
      if (current === item) return;
      if (current) close(current);
      var btn = item.querySelector('[data-rs-trigger]');
      var panel = item.querySelector('[data-rs-panel]');
      if (!btn || !panel) return;
      setTop();
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      current = item;
      if (scrim) scrim.hidden = !panel.classList.contains('rs-panel');
    }

    nav.querySelectorAll('.rs-nav__item').forEach(function (item) {
      var btn = item.querySelector('[data-rs-trigger]');
      if (!btn) {
        item.addEventListener('mouseenter', function () {
          clearTimeout(openTimer);
          if (current) closeTimer = setTimeout(function () { close(current); }, CLOSE_DELAY);
        });
        return;
      }
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { open(item); }, current ? 0 : OPEN_DELAY);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { if (current === item) close(item); }, CLOSE_DELAY);
      });
      btn.addEventListener('click', function () {
        clearTimeout(openTimer);
        if (current === item) close(item); else open(item);
      });
      item.addEventListener('focusout', function (e) {
        if (current === item && !item.contains(e.relatedTarget)) close(item);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && current === item) {
          close(item);
          btn.focus();
        }
      });
    });

    if (scrim) {
      scrim.addEventListener('click', function () { close(current); });
      scrim.addEventListener('mouseenter', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { close(current); }, CLOSE_DELAY);
      });
    }
    window.addEventListener('scroll', function () { if (current) setTop(); }, { passive: true });
    window.addEventListener('resize', function () { if (current) setTop(); });
  }

  function initAll() {
    document.querySelectorAll('[data-rs-nav]').forEach(initNav);
  }

  if (!customElements.get('rs-drawer')) {
    class RsDrawer extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.openBtn = this.querySelector('[data-rs-open]');
        this.panel = this.panel || this.querySelector('.rs-mob__panel');
        if (!this.panel || !this.openBtn || this.dataset.rsReady) return;
        this.dataset.rsReady = '1';

        // Move the panel to <body> so no transformed/sticky ancestor can clip it.
        var stale = document.getElementById(this.panel.id);
        if (stale && stale !== this.panel && stale.parentElement === document.body) stale.remove();
        document.body.appendChild(this.panel);

        this.openBtn.addEventListener('click', function () { self.open(); });
        this.panel.querySelectorAll('[data-rs-close]').forEach(function (b) {
          b.addEventListener('click', function () { self.close(); });
        });
        this.panel.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') self.close();
        });

        // One accordion open at a time per level.
        this.panel.querySelectorAll('details').forEach(function (d) {
          d.addEventListener('toggle', function () {
            if (!d.open || !d.parentElement) return;
            var sel = d.classList.contains('rs-sub') ? 'rs-sub' : 'rs-acc';
            Array.prototype.forEach.call(d.parentElement.children, function (sib) {
              if (sib !== d && sib.tagName === 'DETAILS' && sib.classList.contains(sel)) sib.open = false;
            });
          });
        });

        // Cart icon in the drawer opens the theme's cart drawer when there is one.
        var cart = this.panel.querySelector('[data-rs-cart]');
        if (cart) {
          cart.addEventListener('click', function (e) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (document.querySelector('cart-drawer') && bubble) {
              e.preventDefault();
              self.close(true);
              bubble.click();
            }
          });
        }

        window.matchMedia('(min-width: 992px)').addEventListener('change', function (mq) {
          if (mq.matches && !self.panel.hidden) self.close(true);
        });
      }

      disconnectedCallback() {
        if (this.panel && this.panel.parentElement === document.body) {
          this.panel.remove();
          document.body.classList.remove('rs-lock');
        }
      }

      open() {
        this.panel.hidden = false;
        document.body.classList.add('rs-lock');
        this.openBtn.setAttribute('aria-expanded', 'true');
        var closeBtn = this.panel.querySelector('[data-rs-close]');
        if (closeBtn) closeBtn.focus();
      }

      close(skipFocus) {
        this.panel.hidden = true;
        document.body.classList.remove('rs-lock');
        this.openBtn.setAttribute('aria-expanded', 'false');
        if (!skipFocus) this.openBtn.focus();
      }
    }
    customElements.define('rs-drawer', RsDrawer);
  }

  window.RsNav = { init: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
